/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_InstallInputs */

const en_cc_install = /** @type {(inputs: Cc_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install the extension`)
};

const id_cc_install = /** @type {(inputs: Cc_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasang ekstensi`)
};

/**
* | output |
* | --- |
* | "Install the extension" |
*
* @param {Cc_InstallInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_install = /** @type {((inputs?: Cc_InstallInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_InstallInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_install(inputs)
	return en_cc_install(inputs)
});